module.exports = __webpack_public_path__ + "img/contact_me_qr.aef465ef.png";